import React from "react"

function IconFontSize() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 -4 18 20"><title>ic_format_size_18px</title>
      <g fill="#30659B">
        <path d="M1 9h3v6h2V9h3V7H1v2zm6-6v2h4v10h2V5h4V3H7z"></path>
      </g>
    </svg>
  )
}

export default IconFontSize